/**
 * Do not edit directly, this file was auto-generated.
 */

export const ColorTextPrimary = "#1A1A1A";
export const ColorTextSecondary = "#1A1A1A";
export const ColorBackgroundPrimary = "#D1B98F";
export const ColorBackgroundSecondary = "#B38B44";
export const ColorIconPrimary = "#1A1A1A";
export const ColorIconSecondary = "#1A1A1A";
export const ColorBorderPrimary = "#795A24";
export const ColorBorderSecondary = "#A1A5B2";
